export default "__VITE_ASSET__BruGfinU__"